"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            var ModuleLinkGroup = /** @class */ (function (_super) {
                __extends(ModuleLinkGroup, _super);
                function ModuleLinkGroup() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.onClick = function (event) {
                        DynReact.ModuleStore.setExpanded(_this.props.Id, !_this.props.Expanded);
                        if (event && event.target && event.type === "click") {
                            _this.props.SetSelectedFlyoutItem(Array.prototype.indexOf.call(event.target.parentElement.children, event.target));
                        }
                    };
                    return _this;
                }
                ModuleLinkGroup.prototype.render = function () {
                    var classes = "modulesFlyout-LinkGroup" + (this.props.Level > 0 ? " modulesFlyout-indent" : "");
                    classes = this.props.Last ? classes + " modulesFlyout-last" : classes;
                    classes = this.props.Expanded ? classes + " modulesFlyout-isExpanded ChevronDown-symbol" : classes + " ChevronRight-symbol";
                    return (React.createElement("a", { "aria-expanded": this.props.Expanded, "aria-label": this.props.Label, "aria-level": this.props.Level + 1, className: classes, "data-dyn-expanded": this.props.Expanded, "data-dyn-selected": this.props.Selected, "data-dyn-title": this.props.Label, id: this.props.Id, onClick: this.onClick, onKeyDown: this.keyHandler, onMouseEnter: this.onmouseenter, role: "treeitem", tabIndex: -1 }, this.props.Label));
                };
                return ModuleLinkGroup;
            }($dyn.DynReact.GroupHeading));
            UI.ModuleLinkGroup = ModuleLinkGroup;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModuleLinkGroup.js.map
